var escape = require("../../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* This stylesheet generated by Transfonter (https://transfonter.org) on August 29, 2017 10:35 AM */\n\n@font-face {\n\tfont-family: 'Byom Icons';\n\tsrc: url(" + escape(require("./ByomIcons.eot")) + ");\n\tsrc: url(" + escape(require("./ByomIcons.eot")) + "?#iefix) format('embedded-opentype'),\n\t\turl(" + escape(require("./ByomIcons.woff")) + ") format('woff'),\n\t\turl(" + escape(require("./ByomIcons.ttf")) + ") format('truetype');\n\tfont-weight: normal;\n\tfont-style: normal;\n}\n", ""]);

// exports
